module.exports = __webpack_public_path__ + "static/media/image6.0befe6fb.jpg";